import React, { Component, useRef } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { Col, Row, Card, CardHeader, CardBody } from "reactstrap";
import _ from "lodash";
import LottieLoader from "../../LottieLoader";
import lottieLoaderFile from "../../../files/animation/loading.json";
import lottieEmptyFile from "../../../files/animation/empty_new.json";
import ReactToPrint from "react-to-print";
import ThirtyDaysSummaryDetails from "./ThirtyDaysSummaryDetails";
import PatientProfileHeaderPrint from "../../Reusable/PatintProfileHeaderPrint";
class ThirtyDaysSummary extends Component {
  constructor(props) {
    super(props);
    this.componentRef = React.createRef();
  }
  componentDidMount() {
    this.props.dispatch({
      type: "DO_GET_THIRTY_DAYS_SUMMARY",
      payload: { user: this.props.currentUserId, timeZone: moment.tz.guess() },
    });
    this.props.dispatch({
      type: "DO_GET_EXPECTATION_CAREPLAN_PATIENT",
      payload: { user: this.props.currentUserId },
    });
  }
  handleBeforePrint = () => {
    // Change the title of the document before printing
    document.title = `30 Day Summary (${
      this.props.fname + " " + this.props.lname
    })`;
  };
  handleAfterPrint = () => {
    document.title = "MYVITALVIEW";
  };
  render() {
    const readingSubType = this.props.readingSubTypes.filter(
      (item) => item.description !== "Weight Difference"
    );
    let readingsThirtyDaysFilter = this.props.readingsThirtyDays;
    return (
      <div className={`content-wrap mx-auto`}>
        <div>
          <Row className="header-device-list">
            <Col sm="6" className="center-label remove-table-padding">
              <h3 className="text-center title-device">
                <i class="mdi mdi-account"></i> 30 Day Summary
              </h3>
            </Col>
            <Col sm="6" className="remove-table-padding right-row">
              <div className="d-flex flex-column flex-md-row align-items-start align-items-md-end justify-content-start justify-content-md-end">
                <h3 className="text-center title-device right-row mr-4">
                  <i class="mdi mdi-calendar-multiple-check"></i> Adherence Days
                  : {this.props.adhenrenceDay}
                </h3>
                <ReactToPrint
                  trigger={() => (
                    <button
                      className="btn btn-info print-click-cls m-0"
                      disabled={this.props.ongoingThirtyDaysRequest}
                    >
                      <i
                        class="mdi mdi-cloud-print"
                        style={{ fontSize: 20 }}
                      ></i>
                      Print
                    </button>
                  )}
                  content={() => this.componentRef.current}
                  onBeforePrint={() => this.handleBeforePrint()}
                  onAfterPrint={() => this.handleAfterPrint()}
                ></ReactToPrint>
              </div>
            </Col>
          </Row>
          <div className="text-center" style={{ display: "none" }}>
            <div ref={this.componentRef}>
              <div className="print-page-title">
                Required Documentation for CPT Code 99454
              </div>
              <PatientProfileHeaderPrint
                profile={this.props.profile}
                latestReadingUser={this.props.latestReadingUser}
                ccmTotalDuration={this.props.ccmTotalDuration}
                rpmTotalDuration={this.props.rpmTotalDuration}
              ></PatientProfileHeaderPrint>
              <div className="mt-3">
                {!this.props.ongoingThirtyDaysRequest &&
                ((this.props.bodyTraceReadings &&
                  this.props.bodyTraceReadings.length > 0) ||
                  (readingsThirtyDaysFilter &&
                    readingsThirtyDaysFilter.length > 0)) ? (
                  <ThirtyDaysSummaryDetails
                    readingSubType={readingSubType}
                    readingsThirtyDaysFilter={readingsThirtyDaysFilter}
                    bodyTraceReadings={this.props.bodyTraceReadings}
                    isBloodPressureReadingThirtyDaysSummary={
                      this.props.isBloodPressureReadingThirtyDaysSummary
                    }
                    patientCarePlanExpectations={
                      this.props.patientCarePlanExpectations
                    }
                    fname={this.props.fname}
                    lname={this.props.lname}
                    adhenrenceDay={this.props.adhenrenceDay}
                    print={true}
                  ></ThirtyDaysSummaryDetails>
                ) : (
                  <div className="text-center" style={{ marginTop: "15%" }}>
                    <LottieLoader
                      loadLoop={false}
                      autoplayLoop={true}
                      source={lottieEmptyFile}
                      Lheight={300}
                      Lwidth={300}
                      title={"Sorry! No data found"}
                      subTitle={"We can't find any 30 summary data."}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          {!this.props.ongoingThirtyDaysRequest &&
            ((this.props.bodyTraceReadings &&
              this.props.bodyTraceReadings.length > 0) ||
              (readingsThirtyDaysFilter &&
                readingsThirtyDaysFilter.length > 0)) && (
              <div className="thirty-days-summary-cards">
                <ThirtyDaysSummaryDetails
                  readingSubType={readingSubType}
                  readingsThirtyDaysFilter={readingsThirtyDaysFilter}
                  bodyTraceReadings={this.props.bodyTraceReadings}
                  isBloodPressureReadingThirtyDaysSummary={
                    this.props.isBloodPressureReadingThirtyDaysSummary
                  }
                  patientCarePlanExpectations={
                    this.props.patientCarePlanExpectations
                  }
                  fname={this.props.fname}
                  lname={this.props.lname}
                  adhenrenceDay={this.props.adhenrenceDay}
                ></ThirtyDaysSummaryDetails>
              </div>
            )}
        </div>
        {!this.props.ongoingThirtyDaysRequest &&
          this.props.bodyTraceReadings &&
          this.props.bodyTraceReadings.length == 0 &&
          readingsThirtyDaysFilter &&
          readingsThirtyDaysFilter.length == 0 && (
            <div className="text-center">
              <LottieLoader
                loadLoop={false}
                autoplayLoop={true}
                source={lottieEmptyFile}
                Lheight={300}
                Lwidth={300}
                title={"Sorry! No data found"}
                subTitle={"We can't find any summary data."}
              />
            </div>
          )}
        {this.props.ongoingThirtyDaysRequest && (
          <LottieLoader
            loadLoop={true}
            autoplayLoop={true}
            source={lottieLoaderFile}
            Lheight={150}
            Lwidth={150}
            subTitle={"Please Wait ..."}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps({ careprovider, auth, user }) {
  const {
    bodyTraceReadings,
    readingsThirtyDays,
    adhenrenceDay,
    patientCarePlanExpectations,
    isGenericSuccess,
    isGenericError,
    ongoingThirtyDaysRequest,
    genericErrorMessage,
    isBloodPressureReadingThirtyDaysSummary,
    latestReadingUser,
    ccmTotalDuration,
    rpmTotalDuration,
  } = careprovider;
  const { readingSubTypes, readingType } = auth;
  const profile = user.profile;
  return {
    bodyTraceReadings,
    readingsThirtyDays,
    adhenrenceDay,
    patientCarePlanExpectations,
    isGenericSuccess,
    isGenericError,
    genericErrorMessage,
    readingSubTypes,
    readingType,
    ongoingThirtyDaysRequest,
    isBloodPressureReadingThirtyDaysSummary,
    latestReadingUser,
    ccmTotalDuration,
    rpmTotalDuration,
    profile,
  };
}
export default connect(mapStateToProps)(ThirtyDaysSummary);
